import { KrCard } from '@/common/card/KrCard';
import { Grid } from '@/common/grid/Grid';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const McoFinTopCtrtCard = ({ formValues, idToProgType }) => {
  const { rbtPeriodId, pbmIds, brandProdIds, progTypeIds } = formValues;

  const rsrc = useRsrc();
  const gridRef = useRef();

  const [topCtrtValueType, setCtrtValueType] = useNavStateSync('topCtrtValueType', 'inv');

  const [data, setData] = useState([]);
  const [fieldDefs, setFieldDefs] = useState();

  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {
    let fieldDefs = [
      { field: 'name' },
      { field: 'code', module: 'md', entity: 'CTRT', type: 'HYPERLINK' },
      { field: 'value', type: 'MONEY', sort: 'desc' },
    ];

    setFieldDefs(fieldDefs);
  }, []);

  useEffect(() => {
    const reqParam = {
      periodId: rbtPeriodId,
      pbmIds,
      brandIds: brandProdIds,
      progTypes: progTypeIds.map((id) => idToProgType[id]),
      topCtrtValueType,
    };

    rsrc.data('sc', 'MCO_TOP_CTRT_GRID_DATA_PLUGIN', reqParam).then((data) => {
      setData(data);
    });
  }, [rbtPeriodId, pbmIds, brandProdIds, progTypeIds, topCtrtValueType]);

  useEffect(() => {
    setIsGridReady(false);
  }, [fieldDefs]);

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
      gridRef.current.setDataSource(data);
    }
  }, [isGridReady, data]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  if (!fieldDefs) return;

  const topCtrtButtons = (
    <ToggleButtonGroup
      exclusive
      value={topCtrtValueType}
      onChange={(event, value) => {
        if (value) setCtrtValueType(value);
      }}
      size="small"
      sx={{ width: 'fit-content' }}
    >
      <ToggleButton value="inv">Invoice</ToggleButton>
      <ToggleButton value="disp">Dispute</ToggleButton>
      <ToggleButton value="paid">Paid</ToggleButton>
      <ToggleButton value="due">Due</ToggleButton>
    </ToggleButtonGroup>
  );

  return (
    <KrCard title="Top Contracts" buttons={topCtrtButtons}>
      <Grid
        key={JSON.stringify(fieldDefs)}
        ref={gridRef}
        gridOptions={{
          fieldDefs,
          rowModelType: 'clientSide',
          statusBar: null,
        }}
        events={{
          onGridReady,
        }}
      />
    </KrCard>
  );
};
